import { Box, Text, Divider } from '@chatsdet/ui';
import { KnownPageAnalysisJobConfig } from '../KnownPageAnalysisJobConfig.js';
import { WorkflowSuiteJobConfig } from '../WorkflowSuiteJobConfig.js';
import { parsePayloadSafe } from './types.js';

type JobConfigSectionProps = {
  jobType: string;
  payloadJson: string;
  onPayloadChange: (payload: Record<string, unknown>) => void;
  onOrgIdChange?: (orgId: string | null) => void;
  disabled: boolean;
};

const JOB_CONFIG_MAP: Record<
  string,
  { label: string; component: 'knownPage' | 'workflowSuite' }
> = {
  'qa.known-page-analysis': {
    label: 'Known Page Analysis Configuration',
    component: 'knownPage',
  },
  'benchmark.workflow-suite': {
    label: 'Workflow Suite Configuration',
    component: 'workflowSuite',
  },
};

export function JobConfigSection({
  jobType,
  payloadJson,
  onPayloadChange,
  onOrgIdChange,
  disabled,
}: JobConfigSectionProps) {
  const config = JOB_CONFIG_MAP[jobType];
  if (!config) return null;

  const value = parsePayloadSafe(payloadJson);

  const handleChange = (payload: Record<string, unknown>) => {
    onPayloadChange(payload);
    if (onOrgIdChange && 'orgId' in payload) {
      onOrgIdChange((payload.orgId as string) ?? null);
    }
  };

  return (
    <Box>
      <Text size="xs" className="text-muted-foreground mb-2 block">
        {config.label}
      </Text>
      {config.component === 'knownPage' && (
        <KnownPageAnalysisJobConfig value={value} onChange={handleChange} disabled={disabled} />
      )}
      {config.component === 'workflowSuite' && (
        <WorkflowSuiteJobConfig value={value} onChange={onPayloadChange} disabled={disabled} />
      )}
      <Divider className="my-4" />
    </Box>
  );
}
